// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1JwgH","tab":"ProcedureTabs_tab__2lkSS"};